'use client';
import { createTheme, createThemeOptions, Theme } from '@zeus/core';
import { bookingCom } from '@zeus/themes';

const theme: Theme = createTheme(createThemeOptions(bookingCom.light));

export default theme;
